import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getLearningPathProfessorProgresses } from "../../../api/endpoints/LearningPathEndpoints";
import { Paged } from "../../../models/Paged";
import { StudentTableItem } from "../../../models/StudentTableItem";

export default function useGetLearningPathStudentsProgresses(
  learningPathId: string,
) {
  return useMutation<Paged<StudentTableItem>, AxiosError, { page: number }>({
    mutationKey: ["learning-path-professors-progresses", learningPathId],
    mutationFn: ({ page }) =>
      getLearningPathProfessorProgresses(learningPathId, page),
  });
}
